// extracted by mini-css-extract-plugin
export var container = "_3k-0";
export var icon = "_3k-1";
export var text = "_3k-2";